import DataCell from "./DataCell";

export default DataCell;
